import _JSXStyle from "styled-jsx/style";
import { Portal } from '@dhis2-ui/portal';
import { deprecated } from '@dhis2/prop-types';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Layer = _ref => {
  let {
    children,
    className,
    dataTest,
    disablePortal,
    level,
    onBackdropClick,
    onClick,
    position,
    translucent
  } = _ref;
  const resolvedOnClick = onBackdropClick || onClick;
  return /*#__PURE__*/React.createElement(Portal, {
    disable: disablePortal
  }, /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: "jsx-4284133831 " + _JSXStyle.dynamic([["1893150038", [level]]]) + " " + (cx('layer', className, position, {
      translucent
    }) || "")
  }, resolvedOnClick && /*#__PURE__*/React.createElement("div", {
    onClick: event => resolvedOnClick({}, event),
    className: "jsx-4284133831 " + _JSXStyle.dynamic([["1893150038", [level]]]) + " " + "backdrop"
  }), children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1893150038",
    dynamic: [level]
  }, ["div.__jsx-style-dynamic-selector{z-index:".concat(level, ";}")]), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4284133831"
  }, ["div.jsx-4284133831{-webkit-inset-block-start:0;-ms-intb-rlock-start:0;inset-block-start:0;inset-inline-start:0;min-height:100vh;min-width:100vw;}", "div.fixed.jsx-4284133831{position:fixed;height:100vh;width:100vw;}", "div.absolute.jsx-4284133831{position:absolute;height:100%;width:100%;}", "div.translucent.jsx-4284133831{background-color:rgba(33,43,54,0.4);}", "div.backdrop.jsx-4284133831{position:absolute;inset:0;z-index:-1;}"])));
};

Layer.defaultProps = {
  position: 'fixed',
  dataTest: 'dhis2-uicore-layer',
  level: 'auto'
};
Layer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,

  /** Disable the Portal, useful for nesting layers */
  disablePortal: PropTypes.bool,

  /** Z-index level */
  level: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  position: PropTypes.oneOf(['absolute', 'fixed']),

  /** Adds a semi-transparent background */
  translucent: PropTypes.bool,

  /** Backdrop click handler */
  onBackdropClick: PropTypes.func,

  /** Click handler - DEPRECATED */
  onClick: deprecated(PropTypes.func, 'Please use "onBackdropClick" instead')
};
export { Layer };